import Vue from 'vue'
import VueRouter from 'vue-router'
import Api from '@libraries/api/'
import RequestLocale from '@requests/locale'
import { getLocaleKey, languages, getServerParam } from '@constants'
import localeCommon from '@locales/common'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: () => {
      return `/${languages.get(getLocaleKey()).value}`
    }
  },
  {
    path: '/:lang',
    component: {
      template: '<router-view />'
    },
    beforeEnter: (to, from, next) => {
      if (languages.enums.find(l => l.value === to.params.lang)) {
        Api.call(new RequestLocale(to.params.lang, getServerParam().api_key)).then(() => {}).catch(({error}) => {throw error})
        next()
      } else {
        next('/')
      }
    },
    children: [
      {
        path: '',
        name: 'top',
        component: () => import(/* webpackChunkName: "top" */ '../views/top.vue')
      }, {
        path: 'about',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/about.vue')
      }, {
        path: 'series',
        name: 'series',
        component: () => import(/* webpackChunkName: "series" */ '../views/series/index.vue')
      },
      {
        path: 'series/:seriesId',
        name: 'heroes',
        component: () => import(/* webpackChunkName: "heroes" */ '../views/series/_seriesId/index.vue')
      },
      {
        path: 'series/:seriesId/heroes/:heroId',
        name: 'hero',
        component: () => import(/* webpackChunkName: "hero" */ '../views/series/_seriesId/heroes/_heroId/index.vue')
      },
      {
        path: 'series/:seriesId/heroes/:heroId/voted',
        name: 'voted',
        component: () => import(/* webpackChunkName: "voted" */ '../views/series/_seriesId/heroes/_heroId/voted.vue')
      },
      {
        path: 'character',
        name: 'character',
        component: () => import(/* webpackChunkName: "character" */ '../views/character.vue')
      },
      {
        path: 'random',
        name: 'random',
        component: () => import(/* webpackChunkName: "random" */ '../views/random.vue')
      },
      {
        path: 'results',
        name: 'results',
        component: () => import(/* webpackChunkName: "results" */ '../views/results/index.vue')
      },
      {
        path: 'results/:page',
        name: 'results-detail',
        component: () => import(/* webpackChunkName: "results" */ '../views/results/_page/index.vue'),
      },
      {
        path: 'select-type',
        name: 'select-type',
        component: () => import(/* webpackChunkName: "select-type" */ '../views/select-type.vue')
      },
      {
        path: 'mypage',
        name: 'mypage',
        component: () => import(/* webpackChunkName: "mypage" */ '../views/mypage.vue')
      },
      {
        path: 'error',
        name: 'error',
        component: () => import(/* webpackChunkName: "err" */ '../views/error.vue')
      },
      {
        path: '*',
        name: 'err-404',
        component: () => import(/* webpackChunkName: "err" */ '../views/err-404.vue')
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to) => {
  document.title = localeCommon[to.params.lang]['title']
})

export default router
